import type { Teach } from '@pocketprep/types'
import { instructorModule } from '@/store/instructor/module'
import { userModule } from '@/store/user/module'
import { isPromise } from '@/utils'


const getOrganizations = () => {
    const orgInstructors = instructorModule.state.currentUserOrgInstructors.value
    if (orgInstructors && !(isPromise(orgInstructors))) {
        return orgInstructors.reduce<{ [key: string]: Teach.Class.OrganizationJSON }>((acc, orgInstructor) => {
            const newAcc = acc
            // We know organization is not a pointer because we use .include('organization') with OrgInstructor
            newAcc[orgInstructor.organization.objectId] = orgInstructor.organization as Teach.Class.OrganizationJSON
            return newAcc
        }, {})
    } else {
        return {}
    }
}

const getCurrentOrganization = () => {
    const currentOrganizationId = userModule.state.user?.currentOrganization?.objectId
    const organizations = getOrganizations()

    if (currentOrganizationId && currentOrganizationId in organizations) {
        return organizations[currentOrganizationId]
    } else {
        return null
    }
}

const getHasSelfServicePaymentAccess = () => {
    const currentOrg = getCurrentOrganization()
    const customDisabledOrgs =
        JSON.parse(import.meta.env.VUE_APP_SELF_SERVICE_PAYMENT_DISABLED_ORG_IDS || '[]') as string[]
    return currentOrg && !customDisabledOrgs.includes(currentOrg?.objectId)
}

export default {
    getOrganizations,
    getCurrentOrganization,
    getHasSelfServicePaymentAccess,
}
